var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mb-5",attrs:{"fluid":""}},[(_vm.$route.meta.breadcrumb)?_c('b-breadcrumb',{attrs:{"items":_vm.$route.meta.breadcrumb || []}}):_vm._e(),_c('b-card',[_c('b-card-body')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }